import React from 'react';
const costData = [{
  sin: 'Lunes hinchada sin saber qué hacer',
  costo: 'El mismo ciclo el próximo lunes'
}, {
  sin: 'Infusiones random sin criterio',
  costo: 'Plata gastada sin resultado'
}, {
  sin: 'El jean guardado en el cajón',
  costo: 'Un año más esperando usarlo'
}, {
  sin: 'Restricción extrema que no dura',
  costo: 'Efecto rebote garantizado'
}, {
  sin: 'Buscar en Google sin encontrar nada',
  costo: 'Tiempo y energía perdidos'
}];
export function CostOfNotHaving() {
  return <section className="py-20 px-4 bg-black border-t border-white/5" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <div className="mb-12" data-id="element-72">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-73">
            <span className="text-brand-pink" data-id="element-74">⚖️</span> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl shadow-lg overflow-hidden mb-16 border border-white/10" data-id="element-75">
          <div className="overflow-x-auto" data-id="element-76">
            <table className="w-full text-left border-collapse" data-id="element-77">
              <thead data-id="element-78">
                <tr className="bg-brand-pink text-white" data-id="element-79">
                  <th className="p-5 font-bold w-1/2 text-lg text-center" data-id="element-80">
                    Sin MegaPack
                  </th>
                  <th className="p-5 font-bold w-1/2 text-lg border-l border-white/20 text-center" data-id="element-81">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-82">
                {costData.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white/[0.02]' : ''} data-id="element-83">
                    <td className="p-5 text-gray-200 font-medium border-b border-white/5 text-center" data-id="element-84">
                      {row.sin}
                    </td>
                    <td className="p-5 text-brand-pink font-bold border-l border-b border-white/5 text-center" data-id="element-85">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-3xl sm:text-5xl font-black text-brand-green tracking-tight leading-tight" data-id="element-86">
          El próximo lunes puede ser <br className="hidden sm:block" data-id="element-87" />{' '}
          completamente diferente.
        </p>
      </div>
    </section>;
}